import {Collapse, Grid} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Theme} from "@mui/system";

interface SearchBarContainerStylesProps {
  theme: Theme;
  showPac?: boolean;
}

export const SearchBarContainer = styled(Grid, {
  shouldForwardProp: propName => propName !== 'showPac'
})(({theme, showPac}: SearchBarContainerStylesProps) => ({
  borderRight: "0.07em solid #E0E0E0",
  boxShadow: showPac ? "0px 4px 4px rgba(0, 0, 0, 0.25);" : "none",
  width: "100%",
  [theme.breakpoints.down('lg')]: {
    borderRight: "none",
  },
}));

// Corners: pill = tappable (chips, Done), 8px = field or container (this search box), 4px = status label.
export const PacInputWrapper = styled(Grid)(({theme}) => ({
  padding: theme.spacing(2, 2, 1.5),
  width: "100%",
  '& .MuiInputBase-root': {
    borderRadius: theme.shape.borderRadius * 2,
    backgroundColor: '#FAFAFA',
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0.75, 1, 0.75, 2),
  },
  '& .MuiInputBase-root:focus-within': {
    borderColor: theme.palette.primary.main,
  },
  '& .MuiInputAdornment-positionStart .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
}));

export const FilterCollapse = styled(Collapse)(() => ({
  alignItems: 'center',
  justifyContent: 'space-between'
}));
